<div class="pr-3  pl-4 h-full w-full flex flex-col" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Người dùng hệ thống&nbsp;</span>
      <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel"
        nzTooltipPlacement="bottom" nz-tooltip (click)="exportExcel()">
        <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
      </button>
        <button class="flex items-center justify-center text-gray-600" nz-button nzTooltipTitle="Phân nhóm quyền"
        nzTooltipPlacement="bottom" nz-tooltip (click)="phanNhomQuyen()">
        <i nz-icon nzType="usergroup-add" nzTheme="outline"></i>
      </button>

        <button class="flex items-center justify-center text-green-600" nz-button nzTooltipTitle="Thêm"
          nzTooltipPlacement="bottom" nz-tooltip (click)="AddGroup()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
        </button>
        <button class="flex items-center justify-center text-red-600" nz-button nzTooltipTitle="Xóa"
        nzTooltipPlacement="bottom" nz-tooltip (click)="deleteMulti()">
        <i nz-icon nzType="delete" nzTheme="outline"></i>
      </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel"
        nzTooltipPlacement="bottom" nz-tooltip (click)="exportExcel()">
        Xuất Excel
      </button>
        <button class="flex items-center justify-center text-gray-600" nz-button nzTooltipTitle="Phân nhóm quyền"
        nzTooltipPlacement="bottom" nz-tooltip (click)="phanNhomQuyen()">Phân nhóm quyền
        
      </button>
        <button class="flex items-center justify-center" nz-button (click)="AddGroup()">Thêm
        </button>
        <button class="flex items-center justify-center text-red-600" nz-button nzTooltipTitle="Xóa"
        nzTooltipPlacement="bottom" nz-tooltip (click)="deleteMulti()">
        Xóa
      </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel"
        nzTooltipPlacement="bottom" nz-tooltip (click)="exportExcel()">
        <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
        Xuất Excel
      </button>
        <button class="flex items-center justify-center text-gray-600" nz-button nzTooltipTitle="Phân nhóm quyền"
        nzTooltipPlacement="bottom" nz-tooltip (click)="phanNhomQuyen()">
        <i nz-icon nzType="usergroup-add" nzTheme="outline"></i>
        Phân nhóm quyền
      </button>
        <button class="flex items-center justify-center" nz-button (click)="AddGroup()">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
          Thêm
        </button>
        <button class="flex items-center justify-center text-red-600" nz-button nzTooltipTitle="Xóa"
        nzTooltipPlacement="bottom" nz-tooltip (click)="deleteMulti()">
        <i nz-icon nzType="delete" nzTheme="outline"></i>
        Xóa
      </button>
      </ng-container>
    </div>
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Nhóm quyền</nz-form-label>
          <asc-autocomplete [ascModel]="groupControl" (ascModelChange)="changeGroup($event)"
            [placeholder]="'Chọn nhóm quyền'" [getListAC]="getGroupACFn"></asc-autocomplete>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="tenCS" >Tên đăng nhập</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input [(ngModel)]="commonFilter.UserName ? commonFilter.UserName : commonFilter.NormalizedUserName" [ngModelOptions]="{standalone: true}" type="text" placeholder="Nhập tên">
        </nz-form-control>
        </nz-form-item >
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Phòng ban</nz-form-label>
          <asc-autocomplete [ascModel]="boardControl" (ascModelChange)="changeBoard($event)"
            [placeholder]="'Chọn phòng ban'" [getListAC]="getBoardACFn"></asc-autocomplete>
        </nz-form-item>
      </div>
   
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Chức vụ cán bộ quản lý</nz-form-label>
          <asc-autocomplete [ascModel]="positionControl" (ascModelChange)="changePosition($event)"
            [placeholder]="'Chọn chức vụ'" [getListAC]="getPositionACFn"></asc-autocomplete>
        </nz-form-item>
      </div>
      
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Chức vụ nhân viên/giáo viên</nz-form-label>
          <asc-autocomplete [ascModel]="positionGVControl" (ascModelChange)="changePositionGV($event)"
            [placeholder]="'Chọn chức vụ'" [getListAC]="getPositionGVACFn"></asc-autocomplete>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="tenCS" >Mã nhân sự</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input [(ngModel)]="commonFilter.StaffCode" [ngModelOptions]="{standalone: true}" type="text" placeholder="Nhập mã nhân sự">
        </nz-form-control>
        </nz-form-item >
      </div>
  
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="tenCS" >Tên nhân sự</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input [(ngModel)]="commonFilter.FullName" [ngModelOptions]="{standalone: true}" type="text" placeholder="Nhập tên nhân sự">
        </nz-form-control>
        </nz-form-item >
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="email">Trạng thái</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzPlaceHolder="Chọn trạng thái" [(ngModel)]="commonFilter.isActivity" [ngModelOptions]="{standalone: true}">
            <nz-option nzValue="true" nzLabel="Đang hoạt động"></nz-option>
            <nz-option nzValue="false" nzLabel="Không hoạt động"></nz-option>
            <nz-option nzValue="" nzLabel="Tất cả"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item >
      </div>


    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
          nzTooltipPlacement="bottom" nz-tooltip>Xóa tìm kiếm</button>
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="search()">Tìm
            kiếm</button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
          nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="search()"><i nz-icon
              nzType="search" nzTheme="outline"></i></button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          
          <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
            nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'"><i nz-icon nzType="search"
              nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table [nzShowTotal]="rangeTemplate" #Table nzOuterBordered nzShowSizeChanger [nzData]="systemuserList" nzSize="small"
      [nzScroll]="{x: width +'px', y: height + 'px'}" class="absolute w-full" [nzFrontPagination]="false"
      [nzTotal]="Total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex" [nzPageSizeOptions]="pageSizeOptions"
      (nzPageIndexChange)="pageIndexEvent($event)" (nzPageSizeChange)="pageSizeEvent($event)" (nzCurrentPageDataChange)="onCurrentPageDataChange($event)">
      <thead>
        <tr #pageHeaderTable>
          <th nzLeft nzWidth="50px" [(nzChecked)]="checked" [nzIndeterminate]="indeterminate"
          (nzCheckedChange)="onAllChecked($event)"></th>
          <th nzWidth="50px" nzLeft [nzSortFn]="sortNameFn" [nzSortDirections]="'ascend'">STT</th>
          <th nzWidth="100px" nzLeft>Thuộc nhóm</th>
          <th class="col-head">Tên đăng nhập</th>
          <th class="col-head">Họ tên</th>
          <th class="col-head">Trạng thái</th>
          <th class="col-head">Số cơ sở quản lý</th>
          <th class="col-head">Danh sách cơ sở</th>
          <th nzRight nzWidth="100px"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of Table.data; let i = index">
          <td nzLeft [nzChecked]="setOfCheckedId.has(data.id)" (nzCheckedChange)="onItemChecked(data.id, $event)"></td>
          <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td> 
          <td>{{ data.groupName }}</td> 
          <td>{{data.normalizedUserName}}</td>
          <td>{{data.fullName}}</td>
          <td> {{data.isActivity == false ? 'Không hoạt động' : 'Đang hoạt động'}} </td>
          <td> <a class="text-blue-600" nzTooltipTitle="Danh sách quyền nhóm người dùng" nzTooltipPlacement="top"
              nz-tooltip (click)="viewManageSchool(data)">
              <strong>{{data.schoolNumber}}</strong> / {{data.total}}
            </a></td>
            <td> <a class="text-blue-600" nzTooltipTitle="Danh sách quyền nhóm người dùng" nzTooltipPlacement="top"
              nz-tooltip (click)="addSchool(data)">
              <i nz-icon nzType="user" nzTheme="outline"></i></a></td> 
          <td nzRight>
            <div nz-space nzAlign="end" class="space-align-block"> 
              <nz-space-item>
                <a class="text-blue-600" nzTooltipTitle="Sửa" nzTooltipPlacement="top" nz-tooltip
                  (click)="EditGroup(data)">
                  <i nz-icon nzType="edit" nzTheme="outline"></i>
                </a>
              </nz-space-item> 
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ Total }} </ng-template>
<ng-template #tplTitle>
  <div class="flex justify-between">
    <span>{{ titlePopup }}</span>
    <button nz-button class="btn-modal-reside" (click)="handlerResizePopup()">
      <i nz-icon [nzType]="!isResizdePopup ? 'arrows-alt': 'shrink'" nzTheme="outline"></i>
    </button>
  </div>
</ng-template>